import { create } from 'zustand';
import { getPrintRequiredData } from './utils';
import {
  Tratamento,
  TratamentoSementes,
  TratamentoSementesStatus,
} from '../../@types';
import { DataToPrintTS } from './types';

type PrintTratamentoSementeState = {
  dataToPrint: DataToPrintTS;
};

type PrintTratamentoSementeActions = {
  fetchDataToPrint: (baseObject: TratamentoSementes) => Promise<void>;
  clear: () => void;
};

const initialState = {
  dataToPrint: {
    status: 'rascunho' as TratamentoSementesStatus,
    tratamentos: [],
    tratamentosParsed: [],
  },
};

const usePrintTratamentoSementeStore = create<
  PrintTratamentoSementeState & PrintTratamentoSementeActions
>((set) => ({
  ...initialState,
  clear: () => set(initialState),
  fetchDataToPrint: async (baseObject: TratamentoSementes) => {
    const newPrintData = await getPrintRequiredData(baseObject);
    set({ dataToPrint: newPrintData });
  },
}));

export default usePrintTratamentoSementeStore;

export type dataToPrintTratamentoSemente = {
  situacao: TratamentoSementesStatus;
  status: string;
  tratamentos: Tratamento[];
};
